var map = {
	"./img/payments/cash_delivery.png": 301,
	"./img/payments/logo_bancos.png": 203,
	"./img/payments/logo_yape.png": 202,
	"./img/payments/yape.png": 302,
	"./img/products/default-image-notfound.jpg": 33
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/img.*$
// module id = 204
// module chunks = 1